import type { Action } from 'redux';
import dash_api from '../../../../../main/support/dash_api';
import { ReduxAsyncAction } from '../../../../services/ReduxAsyncAction';
import type { GetTikTokAuthenticationUrlPayload } from '../TikTok.types';

const GetTikTokAuthenticationUrl = new ReduxAsyncAction<
  'GET_TIKTOK_AUTHENTICATION_URL',
  void,
  GetTikTokAuthenticationUrlPayload
>('GET_TIKTOK_AUTHENTICATION_URL');
GetTikTokAuthenticationUrl.registerRequest(() => {
  return dash_api
    .get(`/v1/tiktok/get-auth-url?host=${window.location.protocol}//${window.location.host}`)
    .then(({ data }) => {
      return data;
    });
});
export const GET_TIKTOK_AUTHENTICATION_URL = GetTikTokAuthenticationUrl.actionNamespaceConstants;
export const getTikTokAuthenticationUrl = GetTikTokAuthenticationUrl.request;

export type GetTikTokAuthenticationUrlAction = Action<typeof GET_TIKTOK_AUTHENTICATION_URL.response> & {
  data: GetTikTokAuthenticationUrlPayload;
};
